import { Table, Text } from '@mantine/core';

import { AnnualReportOverviewCount } from '@/module/AnnualReport/model/AnnualReportTypes';

import { Content } from '@/core/components';

interface ArticleCountProps {
  overview: AnnualReportOverviewCount;
}

export function ArticleCount({ overview: { papersCount } }: ArticleCountProps) {
  return (
    <Content type="full">
      <Table variant="vertical">
        <Table.Tbody>
          <Table.Tr>
            <Table.Th w="80%">Numărul lucrărilor științifice publicate in extenso</Table.Th>
            <Table.Td>
              <Text
                fs="xl"
                fw="500"
              >
                {papersCount.articlesCount.totalCount}
              </Text>
            </Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Articole publicate în reviste cotate ISI, CU factor de impact</Table.Th>
            <Table.Td>{papersCount.articlesCount.isiWithFiArticlesCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Articole publicate în reviste indexate ISI, fără factor de impact</Table.Th>
            <Table.Td>{papersCount.articlesCount.isiWithoutFiArticlesCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>
              Articole tip proceedings papers publicate în reviste cotate ISI sau volume de proceedings cotate ISI
            </Table.Th>
            <Table.Td>{papersCount.articlesCount.isiProceedingsCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Articole tip proceedings papers publicate în volume BDI</Table.Th>
            <Table.Td>{papersCount.articlesCount.bdiProceedingsCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Articole publicate în reviste indexate BDI</Table.Th>
            <Table.Td>{papersCount.articlesCount.bdiArticlesCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Articole publicate în reviste recunoscute de CNCS, categoria B</Table.Th>
            <Table.Td>{papersCount.articlesCount.cncsArticlesCount}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Content>
  );
}
